const KEY = 'sara.console.lastOrgSlug';

export function readLastOrgSlug(): string | null {
  try {
    const value = localStorage.getItem(KEY);
    return value === null || value === '' ? null : value;
  } catch {
    return null;
  }
}

export function writeLastOrgSlug(slug: string): void {
  try {
    localStorage.setItem(KEY, slug);
  } catch {
    // localStorage may be disabled (private browsing, quota, etc.) — best effort.
  }
}

export function clearLastOrgSlug(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // best effort
  }
}
